/* unplugin-vue-components disabled */import script from "./PageProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./PageProgress.vue?vue&type=script&setup=true&lang=js"

import "./PageProgress.vue?vue&type=style&index=0&id=0fbc8d1c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fbc8d1c"]])

export default __exports__